import { render, staticRenderFns } from "./ForeignCurrency.vue?vue&type=template&id=6542e388&scoped=true"
import script from "./ForeignCurrency.vue?vue&type=script&lang=js"
export * from "./ForeignCurrency.vue?vue&type=script&lang=js"
import style0 from "./ForeignCurrency.vue?vue&type=style&index=0&id=6542e388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542e388",
  null
  
)

export default component.exports